import * as Types from '../../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetProjectOverviewDataQueryVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetProjectOverviewDataQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', companyHourlyOverhead?: number | null, companyProductProcentForCostumer?: number | null } | null, project?: { __typename?: 'Project', hourWage?: number | null, weekendHourProcent?: number | null, mileCost?: number | null, milePrice?: number | null, privMileCost?: number | null, offertSum?: number | null, offertSumWork?: number | null, procent?: number | null, socialInsurance?: number | null, trakDayPrice?: number | null, trakHalfDayPrice?: number | null, trakNightPrice?: number | null, forYear?: string | null, invoicedInOtherSystem?: number | null, days?: { __typename?: 'DayConnection', edges?: Array<{ __typename?: 'DayEdge', node?: { __typename?: 'Day', projectId?: number | null, costTypeId?: number | null, date?: string | null, extra?: number | null, hours?: number | null, hoursToInvoice?: number | null, mile?: number | null, mileToInvoice?: number | null, privMile?: number | null, salary?: number | null, subsistenceDay?: number | null, subsistenceHalfDay?: number | null, subsistenceNight?: number | null, timeHour?: number | null, type?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, type?: number | null, socialFee?: number | null, contractor?: number | null } | null } | null } | null> | null } | null, atas?: { __typename?: 'OfferConnection', edges?: Array<{ __typename?: 'OfferEdge', node?: { __typename?: 'Offer', state?: number | null, calculationRows?: { __typename?: 'UserCalculationRowConnection', edges?: Array<{ __typename?: 'UserCalculationRowEdge', node?: { __typename?: 'UserCalculationRow', cost?: number | null, quantity?: number | null, costPlusProcent?: string | null } | null } | null> | null } | null, todos?: { __typename?: 'TodoConnection', edges?: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', cost?: number | null } | null } | null> | null } | null } | null } | null> | null } | null, acontoList_PreProjectTypeHyperion?: { __typename?: 'acontoListConnection', edges?: Array<{ __typename?: 'acontoListEdge', node?: { __typename?: 'acontoList', sumBox?: string | null } | null } | null> | null } | null } | null };

export type AtaFragment = { __typename?: 'Offer', state?: number | null, calculationRows?: { __typename?: 'UserCalculationRowConnection', edges?: Array<{ __typename?: 'UserCalculationRowEdge', node?: { __typename?: 'UserCalculationRow', cost?: number | null, quantity?: number | null, costPlusProcent?: string | null } | null } | null> | null } | null, todos?: { __typename?: 'TodoConnection', edges?: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', cost?: number | null } | null } | null> | null } | null };

export type DayFragment = { __typename?: 'Day', projectId?: number | null, costTypeId?: number | null, date?: string | null, extra?: number | null, hours?: number | null, hoursToInvoice?: number | null, mile?: number | null, mileToInvoice?: number | null, privMile?: number | null, salary?: number | null, subsistenceDay?: number | null, subsistenceHalfDay?: number | null, subsistenceNight?: number | null, timeHour?: number | null, type?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, type?: number | null, socialFee?: number | null, contractor?: number | null } | null };

export type GetProjectDataWithKpisQueryVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['Int']>;
  fromDate?: Types.InputMaybe<Types.Scalars['DateTime']>;
  toDate?: Types.InputMaybe<Types.Scalars['DateTime']>;
  includeSubProjects?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type GetProjectDataWithKpisQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', useInternalCostAsDefaultProjectCost?: boolean | null, projects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', laborCostsByUser?: { __typename?: 'ProjectCostByUser', total?: number | null, users?: Array<{ __typename?: 'ProjectCostByUserEmployee', id?: number | null, name?: string | null, userType?: string | null, userTypeId?: number | null, contractor?: boolean | null, salaryHours?: number | null, salaryCost?: number | null, salaryTotalCost?: number | null, weekendHours?: number | null, weekendCost?: number | null, weekendTotalCost?: number | null, vacationPercentage?: number | null, vacationTotalCost?: number | null, employerFeePercentage?: number | null, employerFeeTotalCost?: number | null, socialInsurancePercentage?: number | null, socialInsuranceTotalCost?: number | null, allowanceDays?: number | null, allowanceDayCost?: number | null, allowanceDayTotalCost?: number | null, allowanceHalfDays?: number | null, allowanceHalfDayCost?: number | null, allowanceHalfDayTotalCost?: number | null, allowanceNights?: number | null, allowanceNightCost?: number | null, allowanceNightTotalCost?: number | null, miles?: number | null, mileCost?: number | null, milesTotalCost?: number | null, totalCost?: number | null } | null> | null } | null, laborCostsByType?: { __typename?: 'ProjectCostsByLaborType', total?: number | null, users?: Array<{ __typename?: 'ProjectCostsLaborTypeUsers', id?: number | null, name?: string | null, userType?: string | null, hours?: number | null, cost?: number | null, types?: Array<{ __typename?: 'ProjectCostsLaborType', cost?: number | null, hours?: number | null, name?: string | null } | null> | null } | null> | null, types?: Array<{ __typename?: 'ProjectCostsByType', id?: number | null, name?: string | null, hours?: number | null, cost?: number | null, users?: Array<{ __typename?: 'ProjectCostsLaborTypeUser', name?: string | null, userType?: string | null, hours?: number | null, cost?: number | null } | null> | null } | null> | null } | null, mileCosts?: { __typename?: 'ProjectMileCosts', total?: number | null, users?: Array<{ __typename?: 'ProjectMileCostsUser', id?: number | null, name?: string | null, miles?: number | null, milesCost?: number | null } | null> | null, byExtraNormal?: Array<{ __typename?: 'ProjectMileCostByExtraNormal', name?: string | null, miles?: number | null, milesCost?: number | null, users?: Array<{ __typename?: 'ProjectMileCostsByExtraNormalUser', id?: number | null, name?: string | null, miles?: number | null, milesCost?: number | null } | null> | null } | null> | null } | null, productCosts?: { __typename?: 'ProjectProductCosts', total?: number | null, productTypes?: Array<{ __typename?: 'ProjectProductCostsProjectType', name?: string | null, cost?: number | null, products?: Array<{ __typename?: 'ProjectProductCostsProject', name?: string | null, amount?: number | null, price?: number | null, totalCost?: number | null } | null> | null } | null> | null, byExtraNormal?: Array<{ __typename?: 'ProjectProductCostsByExtraNormal', name?: string | null, cost?: number | null, productTypes?: Array<{ __typename?: 'ProjectProductCostsProjectType', name?: string | null, cost?: number | null, products?: Array<{ __typename?: 'ProjectProductCostsProject', name?: string | null, amount?: number | null, price?: number | null, totalCost?: number | null } | null> | null } | null> | null } | null> | null } | null } | null } | null> | null } | null, projectsWithKpis?: { __typename?: 'ProjectWithKpisConnection', edges?: Array<{ __typename?: 'ProjectWithKpisEdge', node?: { __typename?: 'ProjectWithKpis', id?: number | null, kpis?: { __typename?: 'ProjectKpi', costsProductsAmount?: string | null, costsMilesAmount?: string | null, costsSalaryBasedAmount?: string | null, costsSalaryBasedWorkAmount?: string | null, costsUserCostTypesBasedAmount?: string | null, costsUserCostTypesBasedWorkAmount?: string | null, costsOverheadAmount?: string | null, hoursSum?: string | null, hoursExtraSum?: string | null, invoicesTotalAmount?: string | null, invoicesWorkAmount?: string | null, invoicesMaterialAmount?: string | null, invoicesMilesAmount?: string | null, milesSum?: string | null, milesExtraSum?: string | null, invoicesResultsSalaryBasedAmount?: string | null, invoicesResultsUserCostTypesBasedAmount?: string | null, resultsExpectedSalaryBasedAmount?: string | null, resultsExpectedUserCostTypesBasedAmount?: string | null, resultsCoverageInvoicedSalaryBasedPercentage?: string | null, resultsCoverageInvoicedUserCostTypesBasedPercentage?: string | null, resultsCoverageExpectedOfferedSalaryBasedPercentage?: string | null, resultsCoverageExpectedOfferedUserCostTypesBasedPercentage?: string | null, revenuesATAAcceptedAmount?: string | null, revenuesATAInvoicedAmount?: string | null, revenuesMilesAmount?: string | null, revenuesMilesExtraAmount?: string | null, revenuesOfferedAmount?: string | null, revenuesProductsAmount?: string | null, revenuesMaterialExtraAmount?: string | null, revenuesWorkExtraAmount?: string | null, revenuesTotalAmount?: string | null, revenuesWorkAmount?: string | null } | null } | null } | null> | null } | null } | null };

export type ProjectLaborCostByUserFragment = { __typename?: 'ProjectCostByUser', total?: number | null, users?: Array<{ __typename?: 'ProjectCostByUserEmployee', id?: number | null, name?: string | null, userType?: string | null, userTypeId?: number | null, contractor?: boolean | null, salaryHours?: number | null, salaryCost?: number | null, salaryTotalCost?: number | null, weekendHours?: number | null, weekendCost?: number | null, weekendTotalCost?: number | null, vacationPercentage?: number | null, vacationTotalCost?: number | null, employerFeePercentage?: number | null, employerFeeTotalCost?: number | null, socialInsurancePercentage?: number | null, socialInsuranceTotalCost?: number | null, allowanceDays?: number | null, allowanceDayCost?: number | null, allowanceDayTotalCost?: number | null, allowanceHalfDays?: number | null, allowanceHalfDayCost?: number | null, allowanceHalfDayTotalCost?: number | null, allowanceNights?: number | null, allowanceNightCost?: number | null, allowanceNightTotalCost?: number | null, miles?: number | null, mileCost?: number | null, milesTotalCost?: number | null, totalCost?: number | null } | null> | null };

export type ProjectLaborCostByTypeFragment = { __typename?: 'ProjectCostsByLaborType', total?: number | null, users?: Array<{ __typename?: 'ProjectCostsLaborTypeUsers', id?: number | null, name?: string | null, userType?: string | null, hours?: number | null, cost?: number | null, types?: Array<{ __typename?: 'ProjectCostsLaborType', cost?: number | null, hours?: number | null, name?: string | null } | null> | null } | null> | null, types?: Array<{ __typename?: 'ProjectCostsByType', id?: number | null, name?: string | null, hours?: number | null, cost?: number | null, users?: Array<{ __typename?: 'ProjectCostsLaborTypeUser', name?: string | null, userType?: string | null, hours?: number | null, cost?: number | null } | null> | null } | null> | null };

export type ProjectMileCostFragment = { __typename?: 'ProjectMileCosts', total?: number | null, users?: Array<{ __typename?: 'ProjectMileCostsUser', id?: number | null, name?: string | null, miles?: number | null, milesCost?: number | null } | null> | null, byExtraNormal?: Array<{ __typename?: 'ProjectMileCostByExtraNormal', name?: string | null, miles?: number | null, milesCost?: number | null, users?: Array<{ __typename?: 'ProjectMileCostsByExtraNormalUser', id?: number | null, name?: string | null, miles?: number | null, milesCost?: number | null } | null> | null } | null> | null };

export type ProjectProductCostFragment = { __typename?: 'ProjectProductCosts', total?: number | null, productTypes?: Array<{ __typename?: 'ProjectProductCostsProjectType', name?: string | null, cost?: number | null, products?: Array<{ __typename?: 'ProjectProductCostsProject', name?: string | null, amount?: number | null, price?: number | null, totalCost?: number | null } | null> | null } | null> | null, byExtraNormal?: Array<{ __typename?: 'ProjectProductCostsByExtraNormal', name?: string | null, cost?: number | null, productTypes?: Array<{ __typename?: 'ProjectProductCostsProjectType', name?: string | null, cost?: number | null, products?: Array<{ __typename?: 'ProjectProductCostsProject', name?: string | null, amount?: number | null, price?: number | null, totalCost?: number | null } | null> | null } | null> | null } | null> | null };

export type FetchProjectsDataForExcelExportQueryVariables = Types.Exact<{
  projectIds?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Int']>> | Types.InputMaybe<Types.Scalars['Int']>>;
}>;


export type FetchProjectsDataForExcelExportQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', projectsWithKpis?: { __typename?: 'ProjectWithKpisConnection', edges?: Array<{ __typename?: 'ProjectWithKpisEdge', node?: { __typename?: 'ProjectWithKpis', trueId?: string | null, mark?: string | null, clientInfo?: string | null, startDate?: string | null, endDate?: string | null, kpis?: { __typename?: 'ProjectKpi', revenuesTotalAmount?: string | null, revenuesOfferedAmount?: string | null, revenuesATAAmount?: string | null, hoursSum?: string | null, milesSum?: string | null, revenuesWorkAmount?: string | null, revenuesMilesAmount?: string | null, revenuesProductsAmount?: string | null, revenuesMaterialExtraAmount?: string | null, revenuesWorkExtraAmount?: string | null, revenuesMilesExtraAmount?: string | null, revenuesATAAcceptedAmount?: string | null, revenuesATAInvoicedAmount?: string | null, costsSalaryBasedAmount?: string | null, costsUserCostTypesBasedAmount?: string | null, costsSalaryBasedWorkAmount?: string | null, costsUserCostTypesBasedWorkAmount?: string | null, costsMilesAmount?: string | null, costsProductsAmount?: string | null, costsOverheadAmount?: string | null, invoicesTotalAmount?: string | null, resultsExpectedSalaryBasedAmount?: string | null, resultsExpectedUserCostTypesBasedAmount?: string | null, invoicesResultsSalaryBasedAmount?: string | null, invoicesResultsUserCostTypesBasedAmount?: string | null, resultsCoverageInvoicedSalaryBasedPercentage?: string | null, resultsCoverageInvoicedUserCostTypesBasedPercentage?: string | null, resultsCoverageExpectedOfferedSalaryBasedPercentage?: string | null, resultsCoverageExpectedOfferedUserCostTypesBasedPercentage?: string | null } | null } | null } | null> | null } | null } | null };

export const AtaFragmentDoc = gql`
    fragment Ata on Offer {
  state
  calculationRows {
    edges {
      node {
        cost
        quantity
        costPlusProcent
      }
    }
  }
  todos {
    edges {
      node {
        cost
      }
    }
  }
}
    `;
export const DayFragmentDoc = gql`
    fragment Day on Day {
  projectId
  costTypeId
  date
  extra
  hours
  hoursToInvoice
  mile
  mileToInvoice
  privMile
  salary
  subsistenceDay
  subsistenceHalfDay
  subsistenceNight
  timeHour
  type
  user {
    id
    firstName
    lastName
    type
    socialFee
    contractor
  }
}
    `;
export const ProjectLaborCostByUserFragmentDoc = gql`
    fragment ProjectLaborCostByUser on ProjectCostByUser {
  total
  users {
    id
    name
    userType
    userTypeId
    contractor
    salaryHours
    salaryCost
    salaryTotalCost
    weekendHours
    weekendCost
    weekendTotalCost
    vacationPercentage
    vacationTotalCost
    employerFeePercentage
    employerFeeTotalCost
    socialInsurancePercentage
    socialInsuranceTotalCost
    allowanceDays
    allowanceDayCost
    allowanceDayTotalCost
    allowanceHalfDays
    allowanceHalfDayCost
    allowanceHalfDayTotalCost
    allowanceNights
    allowanceNightCost
    allowanceNightTotalCost
    miles
    mileCost
    milesTotalCost
    totalCost
  }
}
    `;
export const ProjectLaborCostByTypeFragmentDoc = gql`
    fragment ProjectLaborCostByType on ProjectCostsByLaborType {
  total
  users {
    id
    name
    userType
    hours
    cost
    types {
      cost
      hours
      name
    }
  }
  types {
    id
    name
    hours
    cost
    users {
      name
      userType
      hours
      cost
    }
  }
}
    `;
export const ProjectMileCostFragmentDoc = gql`
    fragment ProjectMileCost on ProjectMileCosts {
  total
  users {
    id
    name
    miles
    milesCost
  }
  byExtraNormal {
    name
    miles
    milesCost
    users {
      id
      name
      miles
      milesCost
    }
  }
}
    `;
export const ProjectProductCostFragmentDoc = gql`
    fragment ProjectProductCost on ProjectProductCosts {
  total
  productTypes {
    name
    cost
    products {
      name
      amount
      price
      totalCost
    }
  }
  byExtraNormal {
    name
    cost
    productTypes {
      name
      cost
      products {
        name
        amount
        price
        totalCost
      }
    }
  }
}
    `;
export const GetProjectOverviewDataDocument = gql`
    query getProjectOverviewData($projectId: Int) {
  company {
    companyHourlyOverhead
    companyProductProcentForCostumer
  }
  project(id: $projectId) {
    hourWage
    weekendHourProcent
    mileCost
    milePrice
    privMileCost
    offertSum
    offertSumWork
    procent
    socialInsurance
    trakDayPrice
    trakHalfDayPrice
    trakNightPrice
    forYear
    invoicedInOtherSystem
    days {
      edges {
        node {
          ...Day
        }
      }
    }
    atas {
      edges {
        node {
          ...Ata
        }
      }
    }
    acontoList_PreProjectTypeHyperion {
      edges {
        node {
          sumBox
        }
      }
    }
  }
}
    ${DayFragmentDoc}
${AtaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProjectOverviewDataGQL extends Apollo.Query<GetProjectOverviewDataQuery, GetProjectOverviewDataQueryVariables> {
    document = GetProjectOverviewDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProjectDataWithKpisDocument = gql`
    query getProjectDataWithKpis($projectId: Int, $fromDate: DateTime, $toDate: DateTime, $includeSubProjects: Boolean) {
  company {
    useInternalCostAsDefaultProjectCost
    projects(id: $projectId) {
      edges {
        node {
          laborCostsByUser(
            fromDate: $fromDate
            toDate: $toDate
            includeSubprojects: $includeSubProjects
          ) {
            ...ProjectLaborCostByUser
          }
          laborCostsByType(
            fromDate: $fromDate
            toDate: $toDate
            includeSubprojects: $includeSubProjects
          ) {
            ...ProjectLaborCostByType
          }
          mileCosts(
            fromDate: $fromDate
            toDate: $toDate
            includeSubprojects: $includeSubProjects
          ) {
            ...ProjectMileCost
          }
          productCosts(
            fromDate: $fromDate
            toDate: $toDate
            includeSubprojects: $includeSubProjects
          ) {
            ...ProjectProductCost
          }
        }
      }
    }
    projectsWithKpis(
      projectIds: [$projectId]
      fromDate: $fromDate
      toDate: $toDate
      includeSubProjects: $includeSubProjects
    ) {
      edges {
        node {
          id
          kpis {
            costsProductsAmount
            costsMilesAmount
            costsSalaryBasedAmount
            costsSalaryBasedWorkAmount
            costsUserCostTypesBasedAmount
            costsUserCostTypesBasedWorkAmount
            costsOverheadAmount
            hoursSum
            hoursExtraSum
            invoicesTotalAmount
            invoicesWorkAmount
            invoicesMaterialAmount
            invoicesMilesAmount
            milesSum
            milesExtraSum
            invoicesResultsSalaryBasedAmount
            invoicesResultsUserCostTypesBasedAmount
            resultsExpectedSalaryBasedAmount
            resultsExpectedUserCostTypesBasedAmount
            resultsCoverageInvoicedSalaryBasedPercentage
            resultsCoverageInvoicedUserCostTypesBasedPercentage
            resultsCoverageExpectedOfferedSalaryBasedPercentage
            resultsCoverageExpectedOfferedUserCostTypesBasedPercentage
            revenuesATAAcceptedAmount
            revenuesATAInvoicedAmount
            revenuesMilesAmount
            revenuesMilesExtraAmount
            revenuesOfferedAmount
            revenuesProductsAmount
            revenuesMaterialExtraAmount
            revenuesWorkExtraAmount
            revenuesTotalAmount
            revenuesWorkAmount
          }
        }
      }
    }
  }
}
    ${ProjectLaborCostByUserFragmentDoc}
${ProjectLaborCostByTypeFragmentDoc}
${ProjectMileCostFragmentDoc}
${ProjectProductCostFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProjectDataWithKpisGQL extends Apollo.Query<GetProjectDataWithKpisQuery, GetProjectDataWithKpisQueryVariables> {
    document = GetProjectDataWithKpisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchProjectsDataForExcelExportDocument = gql`
    query fetchProjectsDataForExcelExport($projectIds: [Int]) {
  company {
    projectsWithKpis(projectIds: $projectIds) {
      edges {
        node {
          trueId
          mark
          clientInfo
          startDate
          endDate
          kpis {
            revenuesTotalAmount
            revenuesOfferedAmount
            revenuesATAAmount
            hoursSum
            milesSum
            revenuesWorkAmount
            revenuesMilesAmount
            revenuesProductsAmount
            revenuesMaterialExtraAmount
            revenuesWorkExtraAmount
            revenuesMilesExtraAmount
            revenuesATAAcceptedAmount
            revenuesATAInvoicedAmount
            costsSalaryBasedAmount
            costsUserCostTypesBasedAmount
            costsSalaryBasedWorkAmount
            costsUserCostTypesBasedWorkAmount
            costsMilesAmount
            costsProductsAmount
            costsOverheadAmount
            invoicesTotalAmount
            resultsExpectedSalaryBasedAmount
            resultsExpectedUserCostTypesBasedAmount
            invoicesResultsSalaryBasedAmount
            invoicesResultsUserCostTypesBasedAmount
            resultsCoverageInvoicedSalaryBasedPercentage
            resultsCoverageInvoicedUserCostTypesBasedPercentage
            resultsCoverageExpectedOfferedSalaryBasedPercentage
            resultsCoverageExpectedOfferedUserCostTypesBasedPercentage
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchProjectsDataForExcelExportGQL extends Apollo.Query<FetchProjectsDataForExcelExportQuery, FetchProjectsDataForExcelExportQueryVariables> {
    document = FetchProjectsDataForExcelExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }